import store from "../store";

export default async (to, from, next) => {
  // console.log("guard");
  let user = store.getters.user;

  if (!user) {
    await store.dispatch("autoSignIn");
    user = store.getters.user;
  }

  const auth = to?.meta?.auth ?? null;
  const role = user?.role ?? null;

  // console.log(auth, role);

  if (to.name === "NotVerified") {
    if (user && user.verified) {
      next("/personal");
      return;
    }
  }

  if (to.name === "Deactivated") {
    if (user && !user.deactivated) {
      next("/personal");
      return;
    }
  }

  if (!auth) next();
  else {
    if (auth.includes(role)) {
      if (role === "aplicant") {
        if (!user.verified && to.name !== "NotVerified") {
          next("/not-verified");
          return;
        }
      }
      if (user.deactivated && to.name !== "Deactivated") {
        next("/deactivated");
        return;
      }
      next();
    } else {
      next("/signin");
    }
  }
};
